import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useOrderWizard from 'components/OrderWizard/useOrderWizard';
import type { FormikState, FormikValues } from 'formik';
import { useField } from 'formik';
import { useNotification } from 'shared/Notification';

import ProductForm from '../ProductForm';
import ProductFormFields from '../ProductFormFields';
import AddToBasket from './AddToBasket';
import type { IAddProduct } from './types';

export default function AddProduct({ scrollTop }: IAddProduct) {
  const { lastDeliveryDetails, updateLastDeliveryDetails } = useOrderWizard();
  const [{ value: products }, , { setValue }] = useField('products');
  const [{ value: officeLocation }] = useField('officeLocation');
  const [{ value: debtOwner }] = useField('debtOwner');
  const { t } = useTranslation('CreateOrder');
  const { notification } = useNotification();

  const [
    {
      value: { customerReference = '' },
    },
  ] = useField('customer');

  const handleSubmit = useCallback(
    (values, resetForm?: (nextState?: Partial<FormikState<FormikValues>>) => void) => {
      setValue([...products, values]);
      notification(t('ProductForm.notifications.productWasAdded'), 'success');
      updateLastDeliveryDetails(values);

      if (resetForm) resetForm();
      scrollTop();
    },
    [notification, setValue, products, t, updateLastDeliveryDetails, scrollTop]
  );

  return (
    <ProductFormFields
      onSubmit={handleSubmit}
      product={lastDeliveryDetails}
      isDebtOwner={debtOwner === 'true'}
    >
      <ProductForm
        actions={<AddToBasket />}
        location={officeLocation}
        customerReference={customerReference}
        isDebtOwner={debtOwner === 'true'}
      />
    </ProductFormFields>
  );
}
